import { I18n } from '@calendly/i18n'
import { Badge } from '@calendly/ui/components/badge'
import { BareButton } from '@calendly/ui/components/bare-button'
import { useDropdown } from '@calendly/ui/components/dropdown'
import { IconButton } from '@calendly/ui/components/icon-button'
import { SettingsMenuVerticalIcon } from '@calendly/ui/components/icons'
import { BodyText } from '@calendly/ui/components/typography'

import { ViewportDropdownMenu } from 'components/core/viewport_dropdown_menu'

import { ActionSection, Container, Content, InnerContent } from './styles'
import { useETEditorViewportOffset } from '../../../../hooks'
import { etEditorMenuLayerStyle } from '../name_and_color_fields/et_editor_menu_layer'

const CardContent = ({
  icon,
  title,
  subtitle,
  badgeText,
  menuItems,
  htmlId,
  readOnly = false,
  disabled = false,
  sectionHandler = undefined
}) => {
  const [toggle, Dropdown] = useDropdown()
  const viewportOffset = useETEditorViewportOffset()

  if (readOnly && sectionHandler) {
    return (
      <InnerContent
        readOnly
        as={BareButton}
        disabled={disabled}
        onClick={sectionHandler}
        aria-label={`${I18n.t('publisher.action.edit')} ${title}`}
      >
        <div>
          {icon}
        </div>
        <Content>
          <BodyText>{title}</BodyText>
          {subtitle && <BodyText color="muted">{subtitle}</BodyText>}
        </Content>
        <ActionSection>
          {badgeText && <Badge>{badgeText}</Badge>}
        </ActionSection>
      </InnerContent>
    )
  }

  return (
    <InnerContent disabled={disabled}>
      <div>
        {icon}
      </div>
      <Content>
        <BodyText>{title}</BodyText>
        {subtitle && <BodyText color="muted">{subtitle}</BodyText>}
      </Content>
      <ActionSection hasBadge={!!badgeText}>
        {badgeText && <Badge>{badgeText}</Badge>}
        {menuItems && (
          <>
            <IconButton
              id={`${htmlId}-settings`}
              size="small"
              title={I18n.t('publisher.event_types.context.toggle_button', { name: title })}
              onClick={toggle}
            >
              <SettingsMenuVerticalIcon />
            </IconButton>
            <Dropdown>
              <ViewportDropdownMenu
                viewportOffset={viewportOffset}
                style={etEditorMenuLayerStyle}
                mobileMenuStyle={etEditorMenuLayerStyle}
              >
                {menuItems}
              </ViewportDropdownMenu>
            </Dropdown>
          </>
        )}
      </ActionSection>
    </InnerContent>
  )
}

export const StackedCard = ({ icon, card }) => (
  <Container id={card.htmlId}>
    <CardContent
      icon={icon}
      {...card}
    />
  </Container>
)
